<template>
  <!-- 单独的一张图片，仅显示 -->
  <div class="alone-image-setting">
    <table-button class="close-icon" @click="toRemove" message="是否确认删除">
      <yq-icon name="element-ui_close" v-if="removeAble" @click="toRemove"/>
    </table-button>
    <div class="image">
      <slot name="image">
        <alone-image :src="data.itemImage" object-fit="contain"/>
      </slot>
    </div>
    <div class="info">
      <div>{{data.text}}</div>
      <div>{{data.size}}</div>
      <div>
        <el-color-picker v-model="data.textColor" show-alpha :disabled="true"/>
        <el-color-picker v-model="data.textBackground" show-alpha :disabled="true"/>
      </div>
    </div>
  </div>
</template>

<script>


import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import YqIcon from "@/components/YqIcon.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
export default {
  emits: ["remove"],
  props: {
    data: {default: () => {return {}}},
    removeAble: {default: true},
  },
  name: "",
  components: {
    TableButton,
    YqIcon,
    AloneImage
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    toRemove() {
      this.$emit("remove", this.data);
    }
  }
};
</script>

<style lang="scss" scoped>
.alone-image-setting{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid var(--yq-border-color);
  padding: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  margin: 10px 0;
  position: relative;
  .close-icon{
    position: absolute;
    right: 0;
    top: 10px;
    color: var(--el-color-danger);
    font-size: var(--yq-font-size-base);
  }
  &:hover{
    border-color: var(--el-color-primary);
  }
  .image{
    width: 100px;
    aspect-ratio: 1/1;
    margin-right: 10px;
  }
  .info{
    flex: 1;
  }
}
</style>